import { render, staticRenderFns } from "./PlanPriceLine.vue?vue&type=template&id=062186a5&scoped=true"
import script from "./PlanPriceLine.vue?vue&type=script&lang=js"
export * from "./PlanPriceLine.vue?vue&type=script&lang=js"
import style0 from "./PlanPriceLine.vue?vue&type=style&index=0&id=062186a5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "062186a5",
  null
  
)

export default component.exports